import { TEMPLATE_CATEGORY_OPTIONS } from './templateCategory';
import React, { useEffect, useState, useRef } from 'react';
import { Button, Card, CardBody, CardHeader, CardTitle, Col, Row, Container, Input, Label, FormGroup } from 'reactstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { AesDecrypt, AesEncrypt, keyPromise } from '../../../Service/crypto';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { Editor } from '@ckeditor/ckeditor5-core';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';
import { asBlob } from 'html-docx-js-typescript';
import { useDispatch } from 'react-redux';
import Select, { SingleValue } from 'react-select';
import websocket_webservice from '../../../Service/websocket_webservice'
import MasterFieldModal from './MasterFieldModal '
import webservice from '../../../Service/webservice';
import { Info, Plus } from 'react-feather';
import api from '../../../api';

interface IClientOption {
    label: string;
    value: string;
}

// === Prompt Type ===
interface Prompt {
    id: number;
    text: string;
}

const NewTemplateCreation: React.FC = () => {
    const [editorData, setEditorData] = useState<string>('');
    const [decryptedData, setDecryptedData] = useState<any[]>([]);
    const [expandedSection, setExpandedSection] = useState<string | null>(null);
    const [searchQuery, setSearchQuery] = useState<string>('');
    const [fileName, setFileName] = useState<string>('');
    const [Clients, setClients] = useState<any[]>([]);
    const [selectedClientId, setSelectedClientId] = useState<string>('');
    const [selectedClientName, setSelectedClientName] = useState<string>('');
    const [templateCategory, setTemplateCategory] = useState<string>('');
    const [templateCategoryError, setTemplateCategoryError] = useState<string>('');
    const [selectedClient, setSelectedClient] = useState<any>(null);
    const [fullTemplateData, setFullTemplateData] = useState<any[]>([]);
    const [fullClientsList, setFullClientsList] = useState<any[]>([]);
    const [fileNameError, setFileNameError] = useState<string>('');
    const [clientError, setClientError] = useState<string>('');
    const editorRef = useRef<Editor | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [usertype, setUsertype] = useState<string | null>(localStorage.getItem('UserType'));
    const [vendorbasedclientOptions, setvendorbasedclientOptions] = useState<IClientOption[]>([]);
    const UserName = localStorage.UserName;
    const UserId = localStorage.id;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [modalOpen, setModalOpen] = useState(false);
    const toggleModal = () => setModalOpen(prev => !prev);



    useEffect(() => {
        if (usertype !== 'MOS') {
            setSelectedClientName(localStorage.getItem('ClientName') || '');
            setSelectedClientId(localStorage.getItem('ClientId') || '');
        }
    }, [usertype]);

    const handleTemplatePartChange = (newContent: any) => {
        setEditorData(newContent);
    };

    // --------------------------------------------prompt Section------------------------------------------------
    const [mappingPrompts, setMappingPrompts] = useState<Prompt[]>([{ id: 1, text: "" }]);
    useEffect(() => {
        const fetchPrompts = async () => {
            try {
                const response = await api.fetch("api/Template/get-client-prompt-data", {
                    method: "POST",
                    body: JSON.stringify({ selectedClientId })
                });

                if (!response.ok) throw new Error("Failed to fetch prompt data");

                const data = await response.json();

                console.log(data);
                const processPrompts = (items: any, keyName: any) => {
                    return items.flatMap((item: any) =>
                        Object.entries(item[keyName] || {}).map(([key, value]) => {
                            const match = key.match(/_(\d+)$/);
                            return {
                                id: match ? Number(match[1]) : key,
                                text: value || ""
                            };
                        })
                    );
                };

                // === Mapping Prompts ===
                const mapping = processPrompts(data, "mappingPrompts");
                setMappingPrompts(mapping.length > 0 ? mapping : [{ id: 1, text: "" }]);

            } catch (error) {
                console.error("Error fetching prompts:", error);
            }
        };

        // Only fetch if selectedClientId is defined and not empty
        if (selectedClientId) {
            fetchPrompts();
        }
    }, [selectedClientId]);



    // === Add Prompt ===
    const handleAddPrompt = (
        setPrompts: React.Dispatch<React.SetStateAction<Prompt[]>>,
        prompts: Prompt[]
    ) => {
        const newId = prompts.length ? Math.max(...prompts.map(p => p.id)) + 1 : 1;
        setPrompts([...prompts, { id: newId, text: "" }]);
    };

    // === Remove Prompt ===
    const handleRemovePrompt = (
        setPrompts: React.Dispatch<React.SetStateAction<Prompt[]>>,
        prompts: Prompt[],
        id: number
    ) => {
        setPrompts(prompts.filter((p) => p.id !== id));
    };

    // === Handle Input Change ===
    const handleChangePrompt = (
        setPrompts: React.Dispatch<React.SetStateAction<Prompt[]>>,
        prompts: Prompt[],
        id: number,
        newText: string
    ) => {
        const updated = prompts.map((p) =>
            p.id === id ? { ...p, text: newText } : p
        );
        setPrompts(updated);
    };

    // === Transform for Save ===
    const transformPrompts = (
        prompts: Prompt[],
        baseLabel: string
    ): Record<string, string> => {
        const result: Record<string, string> = {};
        prompts.forEach((p, i) => {
            result[`${baseLabel}_${i + 1}`] = p.text;
        });
        return result;
    };
    // === Render Prompt Section ===
    const renderPromptSection = (
        label: string,
        prompts: Prompt[],
        setPrompts: React.Dispatch<React.SetStateAction<Prompt[]>>,
        tooltipContent: string,
        tooltipId: string
    ) => (
        <div className="prompt-section">
            <div className="prompt_tittle-header d-flex align-items-center justify-content-between">
                <h3>{label}</h3>
                <div id={tooltipId} className="promptadd-icon" title={tooltipContent}>
                    <Info style={{ color: "#0080ff", cursor: "pointer" }} />
                </div>
            </div>
            <CardBody>
                <Row>
                    <Col md={10}>
                        {prompts.map((prompt, index) => (
                            <div key={prompt.id} className="d-flex align-items-center mb-2">
                                <FormGroup className="flex-grow-1 mb-0">
                                    <Label for={`prompt-${prompt.id}`}>
                                        {prompts.length > 1
                                            ? `${label} ${index + 1}`
                                            : label}
                                    </Label>
                                    <Input
                                        type="textarea"
                                        className="textpromptmaster"
                                        id={`prompt-${prompt.id}`}
                                        value={prompt.text}
                                        onChange={(e) =>
                                            handleChangePrompt(
                                                setPrompts,
                                                prompts,
                                                prompt.id,
                                                e.target.value
                                            )
                                        }
                                    />
                                </FormGroup>
                                &nbsp;&nbsp;&nbsp;
                                {prompts.length > 1 && (
                                    <Button
                                        color="danger"
                                        onClick={() =>
                                            handleRemovePrompt(setPrompts, prompts, prompt.id)
                                        }
                                        className="circle-button"
                                    >
                                        X
                                    </Button>
                                )}
                            </div>
                        ))}
                    </Col>
                    <Col md={2} className="text-right">
                        <Button
                            color="primary"
                            onClick={() => handleAddPrompt(setPrompts, prompts)}
                            className="circle-button"
                            style={{ marginTop: "24%" }}
                        >
                            <Plus size={10} />
                        </Button>
                    </Col>
                </Row>
            </CardBody>
        </div>
    );

    // ----------------------------------------------------End of prompt Section------------------------------------------------



    const promptsData = {
        mappingPrompts: transformPrompts(mappingPrompts, "MappingPrompt"),
    };





    useEffect(() => {
        const fetchData = async () => {
            const key = await keyPromise
            const EncParams = await AesEncrypt(key, UserId);
            try {
                const response = await api.fetch("api/TemplateCreation/get_patient_details", {
                    method: 'POST',
                    body: JSON.stringify({ EncParams }),
                });
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                const result = await response.json();
                const decryptedResult = await AesDecrypt(key, result);
                if (decryptedResult.message === 'There is no Record Found') {
                    setFullTemplateData([]);
                    setDecryptedData([]);
                } else {
                    const entries = Object.entries(decryptedResult[0]);
                    setFullTemplateData(entries);
                    // Initially show empty unless client is already selected
                    if (!selectedClientId) {
                        setDecryptedData([]);
                    }
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        // Initial fetch of patient data
        fetchData();
        // WebSocket setup
        const socket = new WebSocket(`${websocket_webservice}ws/Tempalatedata/`);
        // socket.onopen = () => console.log('WebSocket connected');
        // socket.onclose = () => console.log('WebSocket closed');
        // socket.onerror = (error) => console.error('WebSocket error:', error);
        socket.onmessage = () => {
            // const change = JSON.parse(event.data);
            // console.log('WebSocket message received:', change);
            // Re-fetch patient data when a WebSocket message is received
            fetchData();
        };
        // Clean up the WebSocket connection when the component unmounts
        return () => {
            if (socket.readyState === 1) { // <-- This is important
                socket.close();
            }
        }
    }, []);

    const get_ClientRoleId = async () => {
        const key = await keyPromise
        const response = await api.fetch('api/clientmanagement/get_client', {
            method: 'GET'
        }).then((response) => response.json());
        const TempData = await AesDecrypt(key, response);        
        return TempData;
    };

    useEffect(() => {
        const fetchRoleId = async () => {
            const response = await get_ClientRoleId();
            setFullClientsList(response);
            const res = response.map((data: any) => ({
                label: data.CompanyName,
                value: data._id,
            }));
            setClients(res);
        };
        // Fetch the initial data
        fetchRoleId();
        // WebSocket setup
        const socket = new WebSocket(`${websocket_webservice}ws/ClientDropdown/`);
        // socket.onopen = () => console.log('WebSocket connected');
        // socket.onclose = () => console.log('WebSocket closed');
        // socket.onerror = (error) => console.error('WebSocket error:', error);
        socket.onmessage = () => {
            // const change = JSON.parse(event.data);
            // console.log('WebSocket message received:', change);
            // Optionally, re-fetch the data to update the state when a WebSocket message is received
            fetchRoleId();
        };
        // Clean up the WebSocket connection when the component unmounts
        return () => {
            if (socket.readyState === 1) { // <-- This is important
                socket.close();
            }
        }
    }, []);

    useEffect(() => {
        if (!selectedClientId || fullTemplateData.length === 0) {
            setDecryptedData([]);
            return;
        }

        const currentClient = fullClientsList.find(c => c._id === selectedClientId || c.id === selectedClientId);
        const selectedFieldsRaw = currentClient?.selectedFields;

        // selectedFields is an object like { Patient: [{field_name, instruction}, ...], ... }
        const selectedFieldNames: string[] = [];
        if (selectedFieldsRaw && typeof selectedFieldsRaw === 'object' && !Array.isArray(selectedFieldsRaw)) {
            Object.values(selectedFieldsRaw).forEach((sectionFields: any) => {
                if (Array.isArray(sectionFields)) {
                    sectionFields.forEach((f: any) => {
                        if (typeof f === 'object' && f.field_name) {
                            selectedFieldNames.push(f.field_name);
                        } else if (typeof f === 'string') {
                            selectedFieldNames.push(f);
                        }
                    });
                }
            });
        } else if (Array.isArray(selectedFieldsRaw)) {
            selectedFieldsRaw.forEach((f: any) => {
                if (typeof f === 'object' && f.field_name) {
                    selectedFieldNames.push(f.field_name);
                } else if (typeof f === 'string') {
                    selectedFieldNames.push(f);
                }
            });
        }

        if (selectedFieldNames.length === 0) {
            setDecryptedData([]);
            return;
        }

        const filteredData = fullTemplateData.map(([sectionKey, sectionValue]) => {
            const fields = Array.isArray(sectionValue) ? sectionValue : Object.values(sectionValue);
            const filteredFields = fields.filter((field: any) => {
                const fieldName = typeof field === 'object' ? field.field_name : field;
                return selectedFieldNames.includes(fieldName);
            });
            return [sectionKey, filteredFields];
        }).filter(([_, fields]) => (fields as any[]).length > 0);

        setDecryptedData(filteredData);
    }, [selectedClientId, fullTemplateData, fullClientsList]);

    const get_companynamevendorbased = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, { id: localStorage.VendorId });
        const response = await api.fetch('api/TemplateCreation/vendorbasedclientOptions', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());
        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const vendorbasedfetchRoleId = async () => {
            const response = await get_companynamevendorbased();
            const res = response.map((data: any) => ({
                label: data.CompanyName,
                value: data.id,
            }));
            setvendorbasedclientOptions(res);
        };
        // Fetch the initial data
        vendorbasedfetchRoleId();
        // WebSocket setup
        const socket = new WebSocket(`${websocket_webservice}ws/ClientDropdown/`);
        // socket.onopen = () => console.log('WebSocket connected');
        // socket.onclose = () => console.log('WebSocket closed');
        // socket.onerror = (error) => console.error('WebSocket error:', error);
        socket.onmessage = () => {
            // Optionally, re-fetch the data to update the state when a WebSocket message is received
            vendorbasedfetchRoleId();
        };
        // Clean up the WebSocket connection when the component unmounts
        return () => {
            if (socket.readyState === 1) { // <-- This is important
                socket.close();
            }
        }
    }, [dispatch]);

    const handleSubmit = async () => {
        let isValid = true;
        if (!fileName.trim()) {
            setFileNameError('Please enter a file name');
            isValid = false;
        } else {
            setFileNameError('');
        }
        if (usertype === 'MOS' && !selectedClient) {
            setClientError('Please select a client');
            isValid = false;
        } else {
            setClientError('');
        }
        if (!templateCategory) {
            setTemplateCategoryError('Please select a template type');
            isValid = false;
        } else {
            setTemplateCategoryError('');
        }
        if (!isValid) return;
        const hasExtension = fileName.endsWith(".docx");
        const Template_Name = hasExtension ? fileName : fileName + ".docx";

        const pattern = /<p>(?!&)(.*?)<\/p>(?!;)/g;

        // Replace : with :$ and </p> with $</p>
        const transformedData = editorData.replace(/:([^<]*)<\/p>/g, ':$$$1$</p>')

        const editorDataCleaned = transformedData
            .replace(/<p>&nbsp;<\/p>/g, '') // Remove empty paragraph tags with non-breaking spaces
            .replace(/<p>/g, '') // Remove opening paragraph tags
            .replace(/<\/p>/g, ''); // Remove closing paragraph tags

        const splitData = editorDataCleaned
            .split('$') // Split the string by the $ symbol
            .filter(item => item.trim() !== ''); // Remove any empty strings from the result

        // Filter to get only the values (ignore labels ending with ':')
        const valuesOnly = splitData.filter(item => !item.endsWith(':'));

        // Extract all codes like D1234
        const matchesCodes = transformedData.match(/D\d{4}/g);
        // Extract all history usage codes like $D1234_History_usage$
        const historyUsageMatches = transformedData.match(/\$D\d{4}_History_usage\$/g) || [];
        // Extract full history usage codes like D0230_History_usage
        const historyUsageCodes = historyUsageMatches
            .map(code => {
                const match = code.match(/D\d{4}/g);
                return match ? match[0] : undefined;
            })
            .filter((code): code is string => typeof code === 'string');
        // Filter out codes from uniqueMatches if they exist in historyUsageCodes
        const historyBaseCodes = historyUsageCodes.map(code => code.split('_')[0]);
        const uniqueMatches = Array.from(new Set(matchesCodes));

        // const replacements = [
        //     { from: "$D0220/D0230$", to: "$D0220/D0230$" },
        //     { from: "$D9110 Palliative$", to: "$D9110 Palliative$" },
        //     { from: "$D2391 to D2394$", to: "$D2391 to D2394$" },
        //     { from: "$D8080 Ortho percentage Coverage$", to: "$D8080 Ortho percentage Coverage$" },
        //     { from: "$D9944 Night Guard$", to: "$D9944 Night Guard$" },
        //     { from: "$D9211/ D9212 Anesthesia$", to: "$D9211/ D9212 Anesthesia$" },
        //     { from: "$D9922/D9923$", to: "$D9922/D9923$" },
        //     { from: "$D8080 ortho_Age limit$", to: "$D8080 ortho_Age limit$" },
        //     { from: "$D1110/D1120 MAX AGE ALLOWED?$", to: "$D1110/D1120 MAX AGE ALLOWED?$" },
        // ];

        const replacements = [
            { from: "$D0220/D0230$", to: "$D0220/D0230$" },
            { from: "$D9110 Palliative$", to: "$D9110 Palliative$" },
            { from: "$D2391 to D2394$", to: "$D2391 to D2394$" },
            { from: "$D8080 Ortho percentage Coverage$", to: "$D8080 Ortho percentage Coverage$" },
            { from: "$D9944 Night Guard$", to: "$D9944 Night Guard$" },
            { from: "$D9211/ D9212 Anesthesia$", to: "$D9211/ D9212 Anesthesia$" },
            { from: "$D9922/D9923$", to: "$D9922/D9923$" },
            { from: "$D8080 ortho_Age limit$", to: "$D8080 ortho_Age limit$" },
            { from: "$D1110/D1120 MAX AGE ALLOWED?$", to: "$D1110/D1120 MAX AGE ALLOWED?$" },
        ];

        let replacedData = transformedData; // initialize with original data

        replacements.forEach(({ from, to }) => {
            replacedData = replacedData.replace(from, to);
        });

        asBlob(replacedData, {}).then((data: any) => {
            const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            });
            const formData = new FormData();
            formData.append("fileName", Template_Name);
            formData.append("templateCategory", templateCategory);
            formData.append("username", UserName);
            formData.append("userId", UserId);

            const promptsDataString = JSON.stringify(promptsData);
            formData.append("promptsData", promptsDataString);
            formData.append("codes", JSON.stringify(uniqueMatches));
            formData.append("historyusages", JSON.stringify(historyBaseCodes));
            if (usertype === 'MOS') {
                formData.append("clientName", selectedClient.label);
                formData.append("clientId", selectedClient.value);
            } else if (usertype === 'Vendor') {
                formData.append("clientName", selectedClient);
                formData.append("clientId", selectedClientId);
            } else if (usertype === 'Client') {
                formData.append("clientName", selectedClientName);
                formData.append("clientId", selectedClientId);
            }
            formData.append("file", blob, "template.docx");
            const fieldWithInstruction: any = {};
            fullTemplateData.forEach(([sectionKey, sectionValue]) => {
                const fields = Array.isArray(sectionValue) ? sectionValue : Object.values(sectionValue);
                const matchedFields = fields.filter((field: any) => {
                    const fieldName = typeof field === 'object' ? field.field_name : field;
                    return valuesOnly.includes(fieldName);
                }).map((field: any) => {
                    if (typeof field === 'object') {
                        return { field_name: field.field_name, instruction: field.instruction || "" };
                    } else {
                        return { field_name: field, instruction: "" };
                    }
                });
                if (matchedFields.length > 0) {
                    fieldWithInstruction[sectionKey] = matchedFields;
                }
            });
            formData.append("Field_with_instruction", JSON.stringify(fieldWithInstruction));
            setIsLoading(true); // Set loading state to true
            axios.post(webservice + "api/TemplateCreation/save_word", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then((response) => {
                    const auditLogData = [
                        {
                            field: "File Name",
                            value: Template_Name,
                        },
                        {
                            field: "User Name",
                            value: localStorage.UserName,
                        },
                        {
                            field: "KEYS",
                            value: valuesOnly,
                        },
                        ...(localStorage.UserType === "Client"
                            ? [{
                                field: "Client Name",
                                value: selectedClientName,
                            },]
                            : []),
                        ...(localStorage.UserType === "MOS"
                            ? [{
                                field: "Client Name",
                                value: selectedClient.label,
                            },]
                            : []),
                    ];
                    const Username = localStorage.UserName;
                    const Refid = response.data
                    const Data = { auditLogData, Username, Refid };

                    api.fetch('api/TemplateCreation/addauditlog', {
                        method: 'POST',
                        body: JSON.stringify({ Data }),
                    });

                    setIsLoading(false); // Set loading state to false
                    Swal.fire({
                        title: "Insurance Verification Platform",
                        html: '<span style="color: green;">Template Created Successfully!</span>',
                        icon: "success",
                        customClass: {},
                        showClass: {
                            popup: "animate__animated animate__flipInX",
                        },
                        buttonsStyling: true,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.value) {
                            navigate("/templateCreation");
                        }
                    });
                })
                .catch((error) => {
                    setIsLoading(false); // Ensure loading state is turned off in case of an error
                    console.error('Error uploading file:', error);
                });
        });
    }

    const toggleSection = (sectionKey: string) => {
        if (expandedSection === sectionKey) {
            setExpandedSection(null);
        } else {
            setExpandedSection(sectionKey);
        }
    };

    const renderFieldNames = (sectionValue: any, sectionKey: string) => {
        const uniqueKeys = new Set<string>();
        const renderKeys = (keys: string[]) => {
            return keys.map((key) => {
                if (!uniqueKeys.has(key)) {
                    uniqueKeys.add(key);
                    return (
                        <li key={key}
                            draggable
                            className="section-title"
                            onDragStart={(e) => handleDragStart(e, key, sectionKey)}
                        >
                            <div className="field-name">
                                &#8226; {key}
                            </div>
                        </li>
                    );
                }
                return null;
            });
        };

        return (
            <ul>
                {sectionValue.map((item: any, index: number) => {
                    const fieldName = typeof item === 'object' ? item.field_name : item;
                    return (
                        <li key={index}>
                            <strong>{renderKeys([fieldName])}</strong>
                        </li>
                    );
                })}
            </ul>
        );
    };


    const handleSelectClientChange = (selectedOption: SingleValue<IClientOption>) => {
        if (selectedOption) {
            setSelectedClient(selectedOption.label);
            setSelectedClientId(selectedOption.value);
        } else {
            setSelectedClient('');
            setSelectedClientId('');
        }
    }


    const handleDragStart = (event: React.DragEvent, data: string, sectionKey: string) => {
        const currentContent = editorRef.current ? editorRef.current.getData() : '';
        const sectionKeyEncoded = sectionKey
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
        const sectionAlreadyInEditor = currentContent.includes(sectionKeyEncoded) || currentContent.includes(sectionKey);
        if (sectionAlreadyInEditor) {
            event.dataTransfer.setData('text/html', `<p>${data}:${data}</p>`);
            event.dataTransfer.setData('text/plain', `${data}:${data}`);
        } else {
            event.dataTransfer.setData('text/html', `<p><strong>${sectionKey}</strong></p><p>${data}:${data}</p>`);
            event.dataTransfer.setData('text/plain', `${sectionKey}\n${data}:${data}`);
        }
    };

    const handleDrop = (event: DragEvent, editor: Editor) => {
        event.preventDefault();
        const data = event.dataTransfer?.getData('text/plain');
        if (data) {
            const viewFragment = editor.data.processor.toView(data);
            const modelFragment = editor.data.toModel(viewFragment);
            editor.model.insertContent(modelFragment, editor.model.document.selection);
        }
    };

    const handleDragOver = (event: DragEvent) => {
        event.preventDefault();
    };

    const filterData = (data: any[], query: string) => {
        if (!query) return data;
        return data.filter(([key, value]) =>
            key.toLowerCase().includes(query.toLowerCase()) ||
            (typeof value === 'object' &&
                Object.keys(value).some((field) => field.toLowerCase().includes(query.toLowerCase())))
        );
    };

    const renderDataCard = () => {
        const filteredData = filterData(decryptedData, searchQuery).filter(([key]) => key !== '_id');
        return (
            <>
                <Breadcrumbs mainTitle='Create New Template' parent='Template Creation' title='Create New Template' to={`/templateCreation`} />
                <Container fluid>
                    <style>
                        {`
                        .ck-editor__editable {
                            min-height: 640px !important;
                            padding: 10px;
                        }
                        .ck-editor-card {
                            margin: 20px;
                            padding: 20px;
                            width: 100%;
                        }
                        .section-title {
                            cursor: pointer;
                            font-weight: bold;
                        }
                        .field-name {
                            margin-left: 20px;
                        }
                        .half-width {
                            width: 60%;
                        }
                        .flex-container {
                            display: flex;
                            width: 100%;
                        }
                        .scrollable-editor {
                            height: 730px; /* Adjust the height as needed */
                            overflow-y: auto;
                        }
                        .ck-editor__editable_inline {
                            height: 100%; /* Ensure the editor content takes the full height of its container */
                        }
                        .card-body ul {
                            padding-left: 20px; /* Moves array data slightly to the right */
                        }
                        .card-body li {
                            margin-bottom: 10px; /* Adds space between each value */
                        }
                        .loading-overlay {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            position: fixed;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            background-color: rgba(0, 0, 0, 0.5);
                            z-index: 10000;
                        }
                        .circle {
                            width: 20px;
                            height: 20px;
                            margin: 5px;
                            border-radius: 50%;
                            background-color: #000;
                            animation: bounce 0.6s infinite alternate;
                        }
                        @keyframes bounce {
                            to {
                                transform: translateY(-50%);
                            }
                        }
                    `}
                    </style>
                    <Row>
                        <Col sm={5}>
                            {isLoading && (
                                <div >
                                    <div className="loading-overlay">
                                        <div id="page">
                                            <div id="container">
                                                <div id="ring"></div>
                                                <div id="ring"></div>
                                                <div id="ring"></div>
                                                <div id="ring"></div>
                                                <div id="h3" style={{ color: "white" }}>Loading...</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <Card style={{ minHeight: '726px', boxShadow: '0 4px 8px rgba(0,0,0,0.3)', borderRadius: '8px', marginTop: '20px' }}>
                                <br />
                                <Row className="px-4 pt-3">
                                    <Col xs="4">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <Link to="/templateCreation">
                                                <Button color="primary">
                                                    Back
                                                </Button>
                                            </Link>
                                        </div>
                                    </Col>
                                    <Col xs="8">
                                        <Input
                                            type="text"
                                            placeholder="Search"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            style={{ maxWidth: '66%', marginLeft: "6%" }}  // Ensure it takes full width of the column
                                        />
                                    </Col>
                                </Row>
                                {localStorage.UserType === 'MOS' && (
                                    <>
                                        <br />
                                        <Row>
                                            <Col md={5} style={{ marginLeft: "4%" }}>
                                                <Label check>Select Client<span style={{ color: 'red' }}> * </span></Label>
                                                <Select
                                                    name="Client"
                                                    options={Clients}
                                                    onChange={(option: any) => {
                                                        setSelectedClient(option);
                                                        setSelectedClientId(option.value);
                                                    }}
                                                    className="react-select"
                                                    classNamePrefix="select"
                                                />
                                                {clientError && <div style={{ color: 'red', marginTop: '5px' }}>{clientError}</div>}
                                            </Col>
                                            <Col md={5}>
                                                <Label>File Name<span style={{ color: 'red' }}> * </span></Label>
                                                <Input
                                                    type="text"
                                                    placeholder="File Name"
                                                    value={fileName}
                                                    onChange={(e) => setFileName(e.target.value)}
                                                    style={{ marginTop: "1%" }}
                                                    onBlur={() => {
                                                        if (!fileName.trim()) {
                                                            setFileNameError('Please enter a file name');
                                                        } else {
                                                            setFileNameError('');
                                                        }
                                                    }}
                                                />
                                                {fileNameError && <div style={{ color: 'red', marginTop: '5px' }}>{fileNameError}</div>}
                                            </Col>
                                            <Col md={2}></Col>
                                        </Row>
                                    </>
                                )}
                                {localStorage.UserType === 'Vendor' && (
                                    <>
                                        <br />
                                        <Row>
                                            <Col md={5} style={{ marginLeft: "4%" }}>
                                                <Label className="form-label" style={{ fontSize: "110%" }}>
                                                    Select Client <span style={{ color: "red" }}> * </span>
                                                </Label>
                                                <Select
                                                    isClearable
                                                    options={vendorbasedclientOptions}
                                                    classNamePrefix="select"
                                                    placeholder=" Client Names "
                                                    className="react-select"
                                                    styles={{
                                                        control: (styles) => ({
                                                            ...styles,
                                                            width: "100%",
                                                            borderColor: "black",
                                                        }),
                                                        placeholder: (styles) => ({
                                                            ...styles,
                                                            textAlign: "center",
                                                        }),
                                                    }}
                                                    value={selectedClient ? { value: selectedClientId, label: selectedClient } : ""}
                                                    onChange={(selectedOption) => {
                                                        handleSelectClientChange(selectedOption as SingleValue<IClientOption>);
                                                    }}
                                                />
                                                {clientError && <div style={{ color: 'red', marginTop: '5px' }}>{clientError}</div>}
                                            </Col>
                                            <Col md={5}>
                                                <Label>File Name<span style={{ color: 'red' }}> * </span></Label>
                                                <Input
                                                    type="text"
                                                    placeholder="File Name"
                                                    value={fileName}
                                                    onChange={(e) => setFileName(e.target.value)}
                                                    style={{ marginTop: "1%" }}
                                                    onBlur={() => {
                                                        if (!fileName.trim()) {
                                                            setFileNameError('Please enter a file name');
                                                        } else {
                                                            setFileNameError('');
                                                        }
                                                    }}
                                                />
                                                {fileNameError && <div style={{ color: 'red', marginTop: '5px' }}>{fileNameError}</div>}
                                            </Col>

                                        </Row>
                                    </>
                                )}
                                {localStorage.UserType !== 'MOS' && localStorage.UserType !== 'Vendor' && (
                                    <>
                                        <br />
                                        <Row>
                                            <Col md={1}></Col>
                                            <Col md={6}>
                                                <Label>File Name<span style={{ color: 'red' }}> * </span></Label>
                                                <Input
                                                    type="text"
                                                    placeholder="File Name"
                                                    value={fileName}
                                                    onChange={(e) => setFileName(e.target.value)}
                                                    style={{ marginTop: "1%" }}
                                                    onBlur={() => {
                                                        if (!fileName.trim()) {
                                                            setFileNameError('Please enter a file name');
                                                        } else {
                                                            setFileNameError('');
                                                        }
                                                    }}
                                                />
                                                {fileNameError && <div style={{ color: 'red', marginTop: '5px' }}>{fileNameError}</div>}
                                            </Col>
                                            <Col md={5}></Col>
                                        </Row>
                                    </>
                                )}
                                <br />
                                <Row>
                                    <Col md={5} style={{ marginLeft: "4%" }}>
                                        <Label>Template Type<span style={{ color: 'red' }}> * </span></Label>
                                        <Select
                                            isClearable
                                            options={TEMPLATE_CATEGORY_OPTIONS}
                                            classNamePrefix="select"
                                            placeholder="Select Type"
                                            className="react-select"
                                            value={templateCategory ? { value: templateCategory, label: templateCategory } : null}
                                            onChange={(option: any) => {
                                                setTemplateCategory(option ? option.value : '');
                                                setTemplateCategoryError('');
                                            }}
                                        />
                                        {templateCategoryError && <div style={{ color: 'red', marginTop: '5px' }}>{templateCategoryError}</div>}
                                    </Col>
                                </Row>
                                <CardHeader>
                                    <h1><center>Drag & Drop the below fields</center></h1>
                                </CardHeader>
                                <CardBody className="card-body" style={{ marginLeft: "18%", height: "400px", overflowY: "auto" }}>
                                    {filteredData.map(([sectionKey, sectionValue]: [string, any], index: number) => (
                                        <React.Fragment key={index}>
                                            <CardTitle style={{ fontSize: '20px' }} tag="h4" className="section-title" onClick={() => toggleSection(sectionKey)}>
                                                <FontAwesomeIcon icon={expandedSection === sectionKey ? faCaretDown : faCaretRight} />
                                                &nbsp;
                                                {sectionKey}
                                            </CardTitle>
                                            &nbsp;
                                            {expandedSection === sectionKey && renderFieldNames(sectionValue, sectionKey)}
                                        </React.Fragment>
                                    ))}
                                </CardBody>

                                <br />
                                <br />
                                <br />
                                <Button
                                    onClick={handleSubmit}
                                    style={{ maxWidth: '25%', minHeight: '35px', position: 'relative', left: '72%', bottom: '32px' }}>
                                    Submit</Button>
                            </Card>
                        </Col>
                        <Col sm={7}>
                            <Card className="ck-editor-card scrollable-editor">
                                <CKEditor
                                    editor={ClassicEditor as any}
                                    data={editorData}
                                    onChange={(event: any, editor: any) => {
                                        const newContent = editor.getData();
                                        handleTemplatePartChange(newContent);
                                    }}
                                    onReady={(editor: Editor) => {
                                        editorRef.current = editor;
                                        const viewDocument = editor.editing.view.document;
                                        viewDocument.on('dragover', (event: any) => {
                                            if (event.domEvent instanceof DragEvent) {
                                                handleDragOver(event.domEvent);
                                            }
                                        });
                                        viewDocument.on('drop', (event: any) => {
                                            if (event.domEvent instanceof DragEvent) {
                                                handleDrop(event.domEvent, editor);
                                            }
                                        });
                                    }}
                                />
                            </Card>
                        </Col>
                    </Row>

                    {/* {localStorage.UserType === "MOS" && localStorage.Role === "Dev Admin" && selectedClient &&(
                    <Card>
                                      <CardHeader style={{ backgroundColor: '#B4B4B3' }}>
                                        <CardTitle tag="h3">Prompt Details</CardTitle>
                                      </CardHeader>
                                      <CardBody>
                                        {renderPromptSection(
                                          "Mapping Prompt",
                                          mappingPrompts,
                                          setMappingPrompts,
                                          "Define prompts used for field mapping",
                                          "mapping-prompt-tooltip"
                                        )}
                                      </CardBody>
                                    </Card>)} */}
                </Container>
            </>
        );
    };
    return renderDataCard();
};

export default NewTemplateCreation;